/// <amd-module name="Reporting/VelocityReport/Pickers/IterationsPickerOptions" />
import * as Resources from "Reporting/VelocityReport/Resources";
import { format } from "VSS/Core/Util/String";
import { IListBoxItem, ListBoxItemType } from "VSSUI/ListBox";

export const customIterationsId = "customiterations";

export function getIterationOptions(): IListBoxItem<number>[] {
    return [
        makeIterationOption(2),
        makeIterationOption(3),
        makeIterationOption(6),
        makeIterationOption(10),
        makeIterationOption(15),
        { id: "separator", type: ListBoxItemType.Divider },
        { id: customIterationsId, text: Resources.CustomIterations }
    ];
}

function makeIterationOption(value: number): IListBoxItem<number> {
    return {
        id: value.toString(),
        text: format(Resources.IterationCountPickerOption, value),
        data: value
    };
}
